module.exports = __webpack_public_path__ + "media/images/pepsi-north-6ccf286ec52620b44835fabefdccbca0.png";